module.exports = __webpack_public_path__ + "media/img/image-not-available-215868f63ec54d60e5aa5bfec35dcd29.png";